<template>
  <div>
    <b-card v-if="stats" no-body class="mb-1">
      <div class="row px-1 py-1">
        <div class="col-md-12 mb-1">
          <v-stats-box
            text="Cari Bilgisi"
            variant="warning"
            icon="business"
            :value="`${stats.CariDetail.CARI_KOD} - ${stats.CariDetail.CARI_ISIM || '-'}`"
            :subtext="`${stats.CariDetail.CARI_ADRES || '-'}`"
          />
        </div>
        <div class="col-md-4 mb-1">
          <v-stats-box text="Borç Toplam" variant="danger" icon="currency_lira" :value="stats.BorcToplam" />
        </div>
        <div class="col-md-4 mb-1">
          <v-stats-box text="Alacak Toplam" variant="warning" icon="currency_lira" :value="stats.AlacakToplam" />
        </div>
        <div class="col-md-4 mb-1">
          <v-stats-box text="Bakiye Toplam" variant="success" icon="currency_lira" :value="stats.BakiyeToplam" />
        </div>
      </div>
    </b-card>
    <div v-else class="text-center">
        <b-spinner class="mr-1" />
        Veriler Yükleniyor...
    </div>

    <b-card no-body>
      <v-table
        ref="table"
        :items-provider="provider"
        pagination="server"
        search
        :initial-per-page="10"
        :fields="fields"
        :buttons="buttons"
      >
        <template #additional-actions>
          <div class="col-auto">
            <v-executer class="ml-1" :action="ekstreModalOpen" text="Ekstre Gönder" />
          </div>
        </template>
      </v-table>
    </b-card>

    <b-modal size="sm" id="send-extre-modal" title="Ekstre Gönder" no-close-on-esc no-close-on-backdrop>
      <p>Ekstreniz sistemde kayıtlı olan <strong>{{ extre.Email }}</strong> adresine gönderilecektir.</p>
      <p>Onaylıyor musunuz?</p>
      <template #modal-footer>
        <v-executer class="ml-1" :loading="loadingExtre" :action="sendExtre" text="Evet, Gönder" />
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BModal, BSpinner } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import { NetsisApi } from '@/api/netsis'
import Auth from '@/utilities/auth'

export default {
  name: 'CustomerPortalView',
  components: {
    BCard,
    BModal,
    BSpinner,
    VStatsBox,
  },
  data() {
    return {
      stats: null,
      loadingExtre: false,
      extre: { Email: null },
      fields: [
        { name: 'Belge No', key: 'BelgeNo', tdClass: 'text-nowrap' },
        { name: 'Tarih', key: 'Tarih', tdClass: 'text-nowrap' },
        // { name: 'Son Taks. Tarihi', key: 'InstallmentLastDay', tdClass: 'text-nowrap' },
        { name: 'Vade Tarihi', key: 'VadeTarihi', tdClass: 'text-nowrap' },
        { name: 'Borç (₺)', key: 'BorcStr', tdClass: 'text-right text-nowrap' },
        { name: 'Alacak (₺)', key: 'AlacakStr', tdClass: 'text-right text-nowrap' },
        { name: 'Kalan Borç (₺)', key: 'KalanBorcStr', tdClass: 'text-right text-nowrap',component:true, componentOptions:{ name:'customer/CustomerDebt' } },
        { name: 'Kapatılmış Tutar (₺)', key: 'KapatilmisTutarStr', tdClass: 'text-right text-nowrap' , component:true, componentOptions:{ name:'customer/CustomerCredit' }},
        { name: 'Bakiye (₺)', key: 'KumilatifBakiyeStr', tdClass: 'text-right text-nowrap' , component:true, componentOptions:{ name:'customer/CustomerBalance' },},
        { name: 'Açıklama', key: 'Aciklama', tdClass: 'text-nowrap' },
        { name: 'Hareket Türü', key: 'HareketTuru', tdClass: 'text-nowrap' },
        { name: 'Durum', key: 'PaymentPoolStatusStr', tdClass: 'text-nowrap' },
      ],
      buttons: [
        { text: 'Faturayı E‑Posta İle Gönder', key: 'send', icon: 'SendIcon', variant: 'secondary', action: this.sendInvoiceDetail, condition: (item) => item.HareketTuru === 'FATURA' },
        { text: 'Fatura Detayı', key: 'detail', icon: 'EyeIcon', variant: 'primary', action: this.getInvoiceDetail, condition: (item) => item.HareketTuru === 'FATURA' },
      ],
    }
  },
  created() {
    Auth.updateAuthHeader()
    const customerCode = Auth.getCustomerCode()
    if (customerCode) {
      this.fetchCustomerStats(customerCode)
    } else {
      this.$result({ data: { Success: false, Message: 'Müşteri kodu token’da bulunamadı.' } })
    }
  },
  methods: {
    provider(paginationModel) {
      const customerCode = Auth.getCustomerCode()
      const payload = { PaginationRequestModel: paginationModel }
      if (customerCode) payload.CariCode = customerCode
      return NetsisApi.customerAccountActionForCustomer(payload)
    },

    /*  Maks. 5000 konrtrollü; */
//   provider(paginationModel) {
//     const MAX = 5000

//     const page =
//         paginationModel.currentPage ?? paginationModel.page ?? paginationModel.Page ?? 1
//     const perPageRaw =
//         paginationModel.perPage ?? paginationModel.PageSize ?? paginationModel.PerPage ?? 100

//     const offset = (page - 1) * perPageRaw
//     const remaining = Math.max(0, MAX - offset)
//     const perPage = Math.min(perPageRaw, remaining)

//     const customerCode = Auth.getCustomerCode()
//     const PaginationRequestModel = { ...paginationModel }

//     if ('perPage' in PaginationRequestModel) PaginationRequestModel.perPage = perPage
//     if ('PageSize' in PaginationRequestModel) PaginationRequestModel.PageSize = perPage
//     if ('PerPage' in PaginationRequestModel) PaginationRequestModel.PerPage = perPage

//     const payload = { PaginationRequestModel }
//     if (customerCode) payload.CariCode = customerCode

//     if (remaining <= 0) {
//         return Promise.resolve({
//         data: { Success: true, Data: { Items: [], Total: MAX } },
//         })
//     }

//     return NetsisApi.customerAccountActionForCustomer(payload).then(res => {
//         try {
//             const serverTotal = res?.data?.Data?.Total
//             if (typeof serverTotal === 'number' && serverTotal > MAX) {
//                 res.data.Data.Total = MAX
//             }
//             } catch (_) { /* - */ }
//             return res
//       })
//     },
    fetchCustomerStats(cariCode) {
      return NetsisApi.customerAccountActionStatsForCustomer(cariCode)
        .then(res => {
          if (res.data?.Success) {
            this.stats = res.data.Data
            this.extre.Email = this.stats?.CariDetail?.CARI_EMAIL || null
          } else {
            this.$result(res)
          }
        })
        .catch(err => this.$result(null, err))
    },
    ekstreModalOpen() {
      this.$showModal('send-extre-modal');
    },
    sendExtre() {
      const code = Auth.getCustomerCode()
      const email = (this.extre.Email || '').trim()
      if (!code || !email) {
        this.$result({ data: { Success: false, Message: 'Cari kodu veya e‑posta eksik.' } })
        return
      }
      this.loadingExtre = true
      NetsisApi.SendExtre(code, email)
        .then(res => {
        this.$result(res)
        if (res.data?.Success) this.$hideModal('send-extre-modal')
        })
        .catch(err => this.$result(null, err))
        .finally(() => { this.loadingExtre = false })
    },
    sendInvoiceDetail(item) {
        const email = this.extre?.Email || this.stats?.CariDetail?.CARI_EMAIL || ''
        const code = Auth.getCustomerCode()
        if (!email || !code) {
          this.$result({ data: { Success: false, Message: 'E‑posta adresi ya da cari kodu bulunamadı.' } })
        return
        }
        NetsisApi.FaturaDetayGonder(email, code, item.BelgeNo)
          .then(res => this.$result(res))
          .catch(err => this.$result(null, err))
    },
    getInvoiceDetail(item) {
        const code = Auth.getCustomerCode()
        if (!code) {
          this.$result({ data: { Success: false, Message: 'Cari kodu bulunamadı.' } })
          return
        }
        if (this.$router.resolve({ name: 'invoice-detail-from-netsis', params: { customerCode: code, documentNumber: item.BelgeNo } }).route.name) {
        const r = this.$router.resolve({ name: 'invoice-detail-from-netsis', params: { customerCode: code, documentNumber: item.BelgeNo } })
        window.open(r.href, '_blank')
        return
        }
        NetsisApi.FaturaDetayIcerikFromNetsis(code, item.BelgeNo)
        .then(res => {
            const w = window.open('', '_blank')
            if (typeof res.data === 'string') {
            w.document.open()
            w.document.write(res.data)
            w.document.close()
            } else {
            w.document.write('<pre>' + JSON.stringify(res.data, null, 2) + '</pre>')
            }
        })
        .catch(err => this.$result(null, err))
    },
    
  },
}
</script>

<style scoped>
</style>